import type { ComponentPropsWithoutRef } from "react";
import classNames from "classnames";
import { Typography } from "../Typography";
import { Notice } from "./Notice";

export const InfoNotice = ({
  children,
  className,
  ...rest
}: ComponentPropsWithoutRef<typeof Notice>) => (
  <Notice
    className={classNames(
      "bg-v2-info/5 border-v2-info/50 text-dark border px-6 py-4",
      className,
    )}
    {...rest}
  >
    <Typography.BodySm color="text-dark" weight="semibold" as="span">
      {children}
    </Typography.BodySm>
  </Notice>
);
